'use strict';
const trackingUtils = require('../modules/utils/tracking.utils');

Odigeo.defineWidget('seo_faq_box', Odigeo.Widget.extend({
    viewClass: Odigeo.View.extend({
        events: {
            'click .seo_view_more': 'onViewMoreButtonClick',
            'click .seo_view_less': 'onViewLessButtonClick',
        },

        onViewMoreButtonClick: function() {
            const hiddenClassName = Odigeo.SessionScope.entryPoint ? 'hidden' : 'od-hidden';
            const fadingLayer = document.getElementsByClassName('od-fading-layer')[0];
            const foldedContent = document.getElementsByClassName('od-seo-folded-content')[0];
            const viewMoreBtn = document.getElementsByClassName('seo_view_more')[0];
            const viewLessBtn = document.getElementsByClassName('seo_view_less')[0];

            fadingLayer.classList.add(hiddenClassName);
            viewMoreBtn.classList.add(hiddenClassName);
            viewLessBtn.classList.remove(hiddenClassName);
            foldedContent.style.height = 'unset';

            trackingUtils.trackEventWithCategory(
                Odigeo.Utils.getTrackingCategory(),
                'cta-linking',
                'see-more'
            );
        },

        onViewLessButtonClick: function() {
            const hiddenClassName = Odigeo.SessionScope.entryPoint ? 'hidden' : 'od-hidden';
            const isMobile = Odigeo.SessionScope.flow === 'mobile';
            const fadingLayer = document.getElementsByClassName('od-fading-layer')[0];
            const foldedContent = document.getElementsByClassName('od-seo-folded-content')[0];
            const viewMoreBtn = document.getElementsByClassName('seo_view_more')[0];
            const viewLessBtn = document.getElementsByClassName('seo_view_less')[0];
            const scrollTarget = document.getElementById('scroll-target');

            fadingLayer.classList.remove(hiddenClassName);
            viewMoreBtn.classList.remove(hiddenClassName);
            viewLessBtn.classList.add(hiddenClassName);
            foldedContent.style.height = isMobile ? '105px' : '72px';

            window.scroll({
                left: 0,
                top: scrollTarget.offsetTop,
                behavior: 'smooth',
            });

            trackingUtils.trackEventWithCategory(
                Odigeo.Utils.getTrackingCategory(),
                'cta-linking',
                'see-less'
            );
        },
    }),
}));
